function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import get from "lodash/get";
import { useCallback } from "react";
import { Control, Controller, FieldPath, FieldValues, useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { z } from "zod";
import { flattenErrorMessages } from "@oui/lib/src/flattenErrorMessages";
import { FormProvider } from "@oui/lib/src/form";
import { recordKeys } from "@oui/lib/src/recordKeys";
import { Checkbox } from "./components/Checkbox";
import { DateTimeInput } from "./components/DateTimeInput";
import { ErrorPresenter } from "./components/ErrorPresenter";
import { ImageInput } from "./components/ImageInput";
import { MaxLengthTextInput } from "./components/MaxLengthTextInput";
import { NumericStepperInput } from "./components/NumericStepperInput/NumericStepperInput";
import { PickerInput } from "./components/PickerInput";
import { RadioInput } from "./components/RadioInput";
import { SegmentedControlInput } from "./components/SegmentedControl";
import { SwitchInput } from "./components/SwitchInput";
import { EmailInput, NumberInput, TextInput } from "./components/TextInput";
export { useZodForm, useZodFormContext } from "@oui/lib/src/form";
export var TextInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(TextInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onBlur: onBlur,
        onChangeValue: onChange,
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function TextFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return TextInputRender(props, rest);
        }
    });
}
export var MaxLengthTextInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(MaxLengthTextInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onBlur: onBlur,
        onChangeValue: onChange,
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function MaxLengthTextFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return MaxLengthTextInputRender(props, rest);
        }
    });
}
export var EmailInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(EmailInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onBlur: onBlur,
        onChangeValue: onChange,
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function EmailFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return EmailInputRender(props, rest);
        }
    });
}
export var PickerInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'] || props.placeholder;
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(PickerInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onClose: onBlur,
        onChangeValue: onChange,
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function PickerFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        if (!v && typeof v !== 'number') return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return PickerInputRender(props, rest);
        }
    });
}
export var NumericStepperInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(NumericStepperInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onChangeValue: onChange,
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function NumericStepperFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        if (!v) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return NumericStepperInputRender(props, rest);
        }
    });
}
export var DateTimeInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(DateTimeInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        mode: "datetime",
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export var DateInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(DateTimeInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        mode: "date",
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function DateFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return DateInputRender(props, rest);
        }
    });
}
export var TimeInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(DateTimeInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        mode: "time",
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function TimeFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return TimeInputRender(props, rest);
        }
    });
}
export var SwitchInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name;
    return /*#__PURE__*/ _jsx(SwitchInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value,
        showOnOff: true
    }, props));
};
export var RadioInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(RadioInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        error: error === null || error === void 0 ? void 0 : error.message,
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value
    }, props));
};
export function RadioFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    return /*#__PURE__*/ _jsx(Controller, {
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return RadioInputRender(props, rest);
        }
    });
}
export var CheckboxInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(Checkbox, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        error: error === null || error === void 0 ? void 0 : error.message,
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value
    }, props));
};
export function CheckboxFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    return /*#__PURE__*/ _jsx(Controller, {
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return CheckboxInputRender(props, rest);
        }
    });
}
var ImageInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(ImageInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        error: error === null || error === void 0 ? void 0 : error.message,
        onChangeValue: function(v) {
            onChange(v);
            onBlur();
        },
        value: value
    }, props));
};
export function ImageFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.string().min(1).safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return ImageInputRender(props, rest);
        }
    });
}
var SegmentedControlInputRender = function(renderProps, _param) {
    var mode = _param.mode, props = _object_without_properties(_param, [
        "mode"
    ]);
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    var finalValue = mode === 'single' ? value ? [
        value
    ] : [] : value || [];
    return /*#__PURE__*/ _jsx(SegmentedControlInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        error: error === null || error === void 0 ? void 0 : error.message,
        onChangeValue: function(newValue) {
            if (mode === 'single') {
                onChange(newValue.filter(function(v) {
                    return v !== finalValue[0];
                })[0]);
            } else {
                onChange(newValue);
            }
            onBlur();
        },
        value: finalValue
    }, props));
};
export function SegmentedControlFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var mode = rest.mode;
        var valid = mode === 'single' ? !!v : !!(Array.isArray(v) && v.length);
        if (!valid) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return SegmentedControlInputRender(props, rest);
        }
    });
}
export var NumberInputRender = function(renderProps, props) {
    var _renderProps_field = renderProps.field, onChange = _renderProps_field.onChange, onBlur = _renderProps_field.onBlur, value = _renderProps_field.value, name = _renderProps_field.name, error = renderProps.fieldState.error;
    var formContext = useFormContext();
    var label = typeof props.label === 'string' && props.label ? props.label : props['aria-label'];
    if (formContext && label) formContext.labels[name] = label;
    return /*#__PURE__*/ _jsx(NumberInput, _object_spread({
        testID: "FormInput_".concat(name.replaceAll('.', '_')),
        onBlur: onBlur,
        onChangeValue: onChange,
        value: value,
        error: error === null || error === void 0 ? void 0 : error.message
    }, props));
};
export function NumberFormInput(_param) {
    var control = _param.control, name = _param.name, shouldUnregister = _param.shouldUnregister, rest = _object_without_properties(_param, [
        "control",
        "name",
        "shouldUnregister"
    ]);
    var validate = rest.required ? function(v) {
        var valid = z.number().safeParse(v);
        if (!valid.success) return 'Required';
        return;
    } : undefined;
    return /*#__PURE__*/ _jsx(Controller, {
        rules: {
            validate: validate
        },
        name: name,
        control: control,
        shouldUnregister: shouldUnregister,
        render: function(props) {
            return NumberInputRender(props, rest);
        }
    });
}
export function useSubFormContext(_schema, _control, name) {
    var form = useFormContext();
    var subformValue = useWatch({
        control: _control,
        name: name
    });
    var _setValue = form.setValue;
    // setValue doesn't play nicely with objects with nested fields... instead we should manually
    // iterate and setValue on each key in the object
    // https://github.com/react-hook-form/react-hook-form/issues/10795
    var setRootValue = useCallback(function(value) {
        if (value === null) {
            _setValue(name, null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = recordKeys(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                _setValue("".concat(name, ".").concat(key), value[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        _setValue,
        name
    ]);
    var setValue = useCallback(function(subpath, value, options) {
        return _setValue("".concat(name, ".").concat(subpath), // eslint-disable-next-line
        value, options);
    }, [
        _setValue,
        name
    ]);
    var _register = form.register;
    var register = useCallback(function(subpath, options) {
        return _register("".concat(name, ".").concat(subpath), options);
    }, [
        _register,
        name
    ]);
    var watch = useCallback(// @ts-expect-error we don't properly handle all overloads
    function(subpath) {
        return subpath ? get(subformValue, subpath) : subformValue;
    }, [
        subformValue
    ]);
    var getName = useCallback(function(subpath) {
        return "".concat(name, ".").concat(subpath);
    }, [
        name
    ]);
    var errors = form.formState.errors;
    var getError = useCallback(function(subpath) {
        return get(errors, subpath ? "".concat(name, ".").concat(subpath) : name);
    }, [
        errors,
        name
    ]);
    return {
        setRootValue: setRootValue,
        setValue: setValue,
        register: register,
        watch: watch,
        getName: getName,
        getError: getError
    };
}
var ErrorResponseSchema = z.discriminatedUnion('__typename', [
    z.object({
        __typename: z.literal('BaseError'),
        message: z.string()
    }),
    z.object({
        __typename: z.literal('SimpleError'),
        message: z.string()
    }),
    z.object({
        __typename: z.literal('ValidationError'),
        message: z.string(),
        fieldErrors: z.array(z.object({
            path: z.array(z.string()),
            message: z.string()
        }))
    })
]);
export function getErrorPresenterProps(param) {
    var labels = param.labels, formState = param.formState, mutationResult = param.mutationResult;
    var serverError = function() {
        var _mutationResult_data;
        var maybeResultError = Object.values((_mutationResult_data = mutationResult === null || mutationResult === void 0 ? void 0 : mutationResult.data) !== null && _mutationResult_data !== void 0 ? _mutationResult_data : {}).map(function(value) {
            return ErrorResponseSchema.safeParse(value);
        }).find(function(res) {
            return res.success;
        });
        if (maybeResultError === null || maybeResultError === void 0 ? void 0 : maybeResultError.success) {
            return maybeResultError.data;
        }
        return;
    }();
    var errorString;
    if (serverError && 'fieldErrors' in serverError) {
        // flatten ValidationError.fieldErrors into a single string
        errorString = serverError.fieldErrors.map(function(fieldError) {
            var path = fieldError.path;
            // strip "input" from the path if it's present
            if (path[0] === 'input') {
                path.shift();
            }
            return "".concat(path.join('.'), " ").concat(fieldError.message);
        }).join('\n');
    } else if (serverError) {
        errorString = (serverError === null || serverError === void 0 ? void 0 : serverError.message) || 'An unknown error has occurred.';
    }
    var formErrors = flattenErrorMessages(formState.errors, labels);
    return {
        error: mutationResult === null || mutationResult === void 0 ? void 0 : mutationResult.error,
        errorString: errorString,
        formErrors: formErrors
    };
}
export function FormContainer(props) {
    return /*#__PURE__*/ _jsxs(FormProvider, _object_spread_props(_object_spread({}, props), {
        children: [
            /*#__PURE__*/ _jsx(ErrorPresenter, _object_spread({}, getErrorPresenterProps({
                mutationResult: props.mutationResult,
                formState: props.formState,
                labels: props.labels
            }))),
            props.children
        ]
    }));
}
export * from "./FormComponent";
export { Controller, FieldValues, Control, FieldPath, useFieldArray };
